import { createContext, useContext, type ReactNode } from "react";
import {
  resolveGoogleBusinessProfileReviewStats,
  type GoogleBusinessProfileReviewStats,
} from "@/lib/google-business-profile-reviews";

const GoogleBusinessProfileReviewStatsContext =
  createContext<GoogleBusinessProfileReviewStats>(
    resolveGoogleBusinessProfileReviewStats(null, null),
  );

type GoogleBusinessProfileReviewStatsProviderProps = {
  stats?: GoogleBusinessProfileReviewStats | null;
  children: ReactNode;
};

export function GoogleBusinessProfileReviewStatsProvider({
  stats,
  children,
}: GoogleBusinessProfileReviewStatsProviderProps) {
  const value = stats ?? resolveGoogleBusinessProfileReviewStats(null, null);

  return (
    <GoogleBusinessProfileReviewStatsContext.Provider value={value}>
      {children}
    </GoogleBusinessProfileReviewStatsContext.Provider>
  );
}

export function useGoogleBusinessProfileReviewStats() {
  return useContext(GoogleBusinessProfileReviewStatsContext);
}
